import React from 'react';
import { motion } from 'framer-motion';

// Componente LoopraLoadingIcon animado (flutuação suave + motion blur)
const LoopraLoading = ({ size = 80 }) => (
  <motion.img
    src="/icons/loopra_loading.webp"
    alt="Loopra Loading"
    style={{ 
      width: size, 
      height: size, 
      display: 'block',
      filter: 'drop-shadow(0 0 20px rgba(103, 93, 255, 0.4))',
      willChange: 'transform, filter'
    }}
    initial={{ y: 0, rotate: 0, opacity: 0.95 }}
    animate={{ 
      y: [-15, 15, -15],
      rotate: [0, 360],
      opacity: [0.95, 1, 0.95],
      filter: [
        'drop-shadow(0 0 20px rgba(103, 93, 255, 0.4)) blur(0px)',
        'drop-shadow(0 0 30px rgba(103, 93, 255, 0.6)) blur(0.3px)',
        'drop-shadow(0 0 20px rgba(103, 93, 255, 0.4)) blur(0px)'
      ]
    }}
    transition={{ 
      y: { 
        duration: 3.5, 
        repeat: Infinity, 
        ease: [0.45, 0.05, 0.55, 0.95] // Custom cubic-bezier ultra suave
      },
      rotate: { 
        duration: 10, 
        repeat: Infinity, 
        ease: 'linear' 
      },
      opacity: { 
        duration: 3.5, 
        repeat: Infinity, 
        ease: 'easeInOut' 
      },
      filter: {
        duration: 3.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }}
    draggable={false}
  />
);

export default LoopraLoading;
